import { render, staticRenderFns } from "./Addconfig.vue?vue&type=template&id=1fbfe59f&scoped=true"
import script from "./Addconfig.vue?vue&type=script&lang=js"
export * from "./Addconfig.vue?vue&type=script&lang=js"
import style0 from "./Addconfig.vue?vue&type=style&index=0&id=1fbfe59f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbfe59f",
  null
  
)

export default component.exports